import { getToken, resetState } from "../utils/index";

export default {
  namespaced: true,
  state: {
    error: null,
    loading: false,
    initialLoad: true,
  },
  mutations: {
    GET_AGENT_LIST_START: (state) => {
      state.loading = true;
    },
    GET_AGENT_LIST_FAILED: (state, error) => {
      state.loading = false;
      state.error = error;
    },
    GET_AGENT_LIST_SUCCESS: (state, agentList) => {
      state.loading = false;
      state.initialLoad = false;
      state.list = agentList;
      console.log(agentList);
    },
  },
  actions: {
    async getAgentList({ commit }) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_AGENT_LIST_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/agents/lists`,
          config
        );
        const data = await response.json();
        commit("GET_AGENT_LIST_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_AGENT_LIST_FAILED", err);
      }
    },
  },
};
